module.exports = __webpack_public_path__ + "static/IBMPlexMono-Italic-cb143f1453de62a6febc058dfc352f0f.woff";